import {
  __spreadProps,
  __spreadValues
} from "./chunk-WNQUEZJF.mjs";

// src/components/analytics/app-router-analytics.tsx
import { State } from "@youversion/analytics-core";
import { Foreground, Impression, initialize as initializeYVAnalytics } from "@youversion/analytics-youversion-private";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
function AppRouterAnalytics({ config }) {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isForegroundFired, setIsForegroundFired] = useState(false);
  useEffect(() => {
    if (config.debug) {
      console.log("initializing app router analytics");
      console.dir({ config }, { depth: null });
    }
    initializeYVAnalytics(__spreadProps(__spreadValues({}, config), { disableDefaultForegroundEvent: true }), () => setIsInitialized(true));
  }, [config]);
  const pathname = usePathname();
  useEffect(() => {
    var _a;
    if (window.yvaDatastore && isInitialized && pathname) {
      const formattedPathname = pathname.replaceAll("[", ":").replaceAll("]", "");
      const currentPathname = State.get("templatedPathname");
      if (formattedPathname !== currentPathname) {
        if ((_a = window.yvaDatastore) == null ? void 0 : _a.config.debug) {
          console.log("updating app router templated pathname");
          console.dir({ formattedPathname, original: { pathname } });
        }
        State.set("templatedPathname", formattedPathname);
        if (!config.disableDefaultForegroundEvent && !isForegroundFired) {
          Foreground.fire();
          setIsForegroundFired(true);
        }
        if (!config.disableDefaultPageImpressions) {
          Impression.Page.fire({});
        }
      }
    }
  }, [
    isInitialized,
    pathname,
    config.debug,
    isForegroundFired,
    config.disableDefaultForegroundEvent,
    config.disableDefaultPageImpressions
  ]);
  return null;
}

export {
  AppRouterAnalytics
};
